import React, { useState } from "react";
import { getDomain, DEFAULT_ENV } from "../../constants";
import EnvironmentSelector from "../options/environment_selector";
import InvisibleRequest from "../options/invisible_request";
import EmbedContainer from "../embed/container";

const TOKENS = {
  staging: "dhQNj1iEEFY67qyZYNiHS1by4WyxzS61",
  validation: "S1xjXyFBkoLraqZaCsF4j4DKX8SG5BAz",
};

const StellantisDemo = () => {
  // Anonymous embed token (aet) du produit Stellantis (workflow wf_sta_X1IScMZekGHW).
  const [token, setToken] = useState(TOKENS[DEFAULT_ENV] || TOKENS.staging);
  const [locale, setLocale] = useState("fr");
  const [environment, setEnvironment] = useState(DEFAULT_ENV);
  const [invisible, setInvisible] = useState(false);
  const [autoCreate, setAutoCreate] = useState(false);
  const domain = getDomain(environment);

  return (
    <div>
      <h1>Stellantis Demo</h1>
      <EnvironmentSelector
        value={environment}
        onChange={(env) => {
          setEnvironment(env);
          setToken(TOKENS[env] || TOKENS.staging);
        }}
      />
      <InvisibleRequest
        value={invisible}
        onChange={(invisible) => setInvisible(invisible)}
      />
      <div>
        <label style={{ marginRight: "10px" }}>Locale:</label>
        <select value={locale} onChange={(e) => setLocale(e.target.value)}>
          <option value="fr">FR</option>
          <option value="nl">NL</option>
        </select>
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Auto Create:</label>
        <input
          type="checkbox"
          checked={autoCreate}
          onChange={(e) => setAutoCreate(e.target.checked)}
        />
      </div>
      <div>
        <label style={{ marginRight: "10px" }}>Anonymous Embed Token:</label>
        <input
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />
      </div>
      {token && (
        <div key={`${token}-${locale}-${autoCreate}`}>
          <EmbedContainer
            embedUrl={`${domain}?aet=${token}&brand=insurandgo&theme=stellantis&locale=${locale}&invisible=${invisible}&autoCreate=${autoCreate}`}
            showCode={true}
            urlToShow={`${domain}?aet=${token}&brand=insurandgo&theme=stellantis&locale=${locale}&autoCreate=${autoCreate}`}
          />
        </div>
      )}
    </div>
  );
};

export default StellantisDemo;
